module.exports = __webpack_public_path__ + "assets/img/mainItem01.9abeabbc.svg";